import { render, staticRenderFns } from "./SurveyExerciseOverview.vue?vue&type=template&id=72050de8&scoped=true&"
import script from "./SurveyExerciseOverview.vue?vue&type=script&lang=ts&"
export * from "./SurveyExerciseOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72050de8",
  null
  
)

export default component.exports